import React from 'react';

import { CircleXmarkRegularIcon } from '../../../../shared/icons/icons';
import Typography from '../../../typography/typography';
import { FilterChipValue } from '../../filter-chips';

import './filter-chip.scss';

interface FilterChipProps extends FilterChipValue {
  onClick: ({ categoryCode, valueCode }) => void;
}

function FilterChip(props: FilterChipProps) {
  const { categoryCode, categoryName, onClick, valueCode, valueName } = props;

  return (
    <Typography
      aria-label={`remove ${valueName}`}
      className="filter-chip"
      onClick={() => onClick({ categoryCode, valueCode })}
      styleName="container"
      tag="button"
    >
      {categoryName}: {valueName}
      <CircleXmarkRegularIcon
        className="filter-chip__close-icon"
        styleName="close-icon"
      />
    </Typography>
  );
}

export default React.memo(FilterChip);
